(function () {
    'use strict';

    var module = angular.module("imApp");

    module.factory("eCommerceMenuService", ['$q', '$ihttp', function ($q, $ihttp) {
        var service = {
            loaded: false,
            genericFunction: function (method_nr, parms) {
                var deferred = $q.defer();

                var parms_genericFunction = {
                    method: method_nr,
                    parameters: parms
                };
                
                $ihttp.post(parms_genericFunction).then(function (data) {
                    service.loaded = true;
                    deferred.resolve(data);
                });

                return deferred.promise;
            }
        };

        return service;
    }]);
})();